import VideoJS from 'video.js';

import * as Controls from '../../ui/UIControlsNames';
import ccSVG from '../../ui/icons/cc.svg';

const TextTrackButton = VideoJS.getComponent('TextTrackButton');
const CaptionsButton = VideoJS.getComponent('CaptionsButton');

const ccIcon = VideoJS.dom.createEl('span', {
    innerHTML: ccSVG,
    className: 'vjs-icon vjs-icon--cc',
}, {
    'aria-hidden': 'true'
});

class ASCaptionsButton extends CaptionsButton {
    constructor(player, options) {
        super(player, options);
        this.menuButton_.el_.appendChild(ccIcon);

        this.handleTextTrackChange = this.handleTextTrackChange.bind(this);
        this.playerTextTracks_ = player.tech_.el().textTracks;
        this.playerTextTracks_.addEventListener('change', this.handleTextTrackChange);
    }

    createItems() {
        return TextTrackButton.prototype.createItems.call(this);
    }

    dispose() {
        super.dispose();
        this.playerTextTracks_.removeEventListener('change', this.handleTextTrackChange);
        this.playerTextTracks_ = null;
    }

    buildCSSClass() {
        return `as-captions-button ${super.buildCSSClass()}`;
    }

    buildWrapperCSSClass() {
        return `as-captions-button-wrapper ${super.buildWrapperCSSClass()}`;
    }

    handleTextTrackChange(event, data) {
        const tracks = event.target;
        let showing = 0; // Start at 1 (captions off), 0 is hidden settings menu

        for (let i = tracks.length; i >= 0; --i) {
            const track = tracks[i];
            if (track && track.mode === 'showing') {
                showing = i + 1;
                break;
            }
        }

        this.items.forEach((menuItem, i) => {
            menuItem.toggleClass('vjs-selected', i === showing);
        });
    }
}

VideoJS.registerComponent(Controls.CAPTIONS_BUTTON, ASCaptionsButton);

export default ASCaptionsButton;



// WEBPACK FOOTER //
// ./src/player/components/ASCaptionsButton.js